import CryptoJS from "crypto-js";
import Config from "../constants/Config";

const ENCRYPT_DECRYPT_SECRET_KEY = Config.ENCRYPT_DECRYPT_KEY;


// Encrypt the object
const encryptData = (data) => {
    const jsonData = JSON.stringify(data);
    return CryptoJS.AES.encrypt(jsonData, ENCRYPT_DECRYPT_SECRET_KEY).toString();
};

// Decrypt the stored data
const decryptData = (encryptedData) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPT_DECRYPT_SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};


const setItem = (key, data) => {
    localStorage.setItem(key,encryptData(data));
}

const getItem = (key) => {
    const encryptedResponse=localStorage.getItem(key);
    if(encryptedResponse!=undefined){
        return JSON.parse(decryptData(encryptedResponse));
    }
    return encryptedResponse;
}

export {
    setItem,
    getItem
}